module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/tabination/normal-pill/normal-pill.component.scss
// module id = ./src/app/features/tabination/normal-pill/normal-pill.component.scss
// module chunks = main